// extracted by css-extract-rspack-plugin
export default {"RemoveButton":"lDA2s","PickerTrigger":"hgWcI","AddTableButton":"TrKNf"};